import { onContentDropped } from "owa-nova-actions";
import { FirstPartyAppId } from "owa-m365-acquisitions/lib/data/M365AppId";
import { getDragData } from "owa-dnd";
import { launchFullComposeFromDropData } from "owa-calendar-forms-launch-handlers";
import { orchestrator, type OrchestratorFunction } from "satcheljs";
import type { ContentDroppedEvent } from "@1js/office-start-appbar-events";

/**
 * Receives Appbar content drop event and dispatches the appropriate action depending on
 * the tile ID of the app that received the drop event.
 *
 * If adding drag-and-drop functionality for an app, add a new case in the below switch statement.
 */
export const onContentDroppedOrchestrator: OrchestratorFunction<{
    event: ContentDroppedEvent;
    owaType: "contentDropped";
}> = orchestrator(onContentDropped, async (actionMessage) => {
    const data = actionMessage.event.data?.();
    switch (data?.tileID) {
        case FirstPartyAppId.Calendar:
            launchFullComposeFromDropData(getDragData(data.dropData));
            break;
        default:
            break;
    }
});
